import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';

class Sidetittel extends React.Component {
	constructor(props) {
		super(props);
		this.titleElement = document.getElementsByTagName('title')[0];
		this.state = {
			rottittel: this.titleElement.innerText,
		};
		while (this.titleElement.firstChild) {
			this.titleElement.removeChild(this.titleElement.firstChild);
		}
	}

	render() {
		const { sidetittel } = this.props;
		const { rottittel } = this.state;
		const fullTittel = sidetittel
			? `${sidetittel} - ${rottittel}`
			: rottittel;

		return ReactDom.createPortal(fullTittel || '', this.titleElement);
	}
}

Sidetittel.defaultProps = {
	sidetittel: '',
};

Sidetittel.propTypes = {
	sidetittel: PropTypes.string,
};

export { Sidetittel };
